import SIdentify from './identify.vue';
export default SIdentify;
